/**
 * Panel component for displaying a MARC field group.
 * Renders a bordered card with a colored header matching the MARC field
 * group colors used in MarcDataDisplay (detail view).
 */
import React, { useMemo } from 'react';
import { getMarcColors } from '../../../styles/marcColors';
var bodyStyle = {
    padding: '16px',
};
var headerRightStyle = {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
};
var MarcFieldPanel = function (_a) {
    var tag = _a.tag, label = _a.label, headerRight = _a.headerRight, children = _a.children;
    var _b = useMemo(function () {
        var colors = getMarcColors(tag);
        return {
            panelStyle: {
                border: "1px solid ".concat(colors.border),
                borderRadius: '6px',
                marginBottom: '16px',
            },
            headerStyle: {
                background: colors.light,
                padding: '8px 16px',
                borderBottom: "1px solid ".concat(colors.border),
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
            },
            tagBadgeStyle: {
                display: 'inline-flex',
                alignItems: 'center',
                padding: '3px 8px',
                fontFamily: "'SF Mono', 'Cascadia Code', 'Consolas', monospace",
                fontWeight: 700,
                fontSize: '0.85rem',
                color: '#fff',
                backgroundColor: colors.dark,
                borderRadius: '4px',
                letterSpacing: '0.02em',
            },
            labelStyle: {
                fontSize: '14px',
                fontWeight: 600,
                color: colors.dark,
            },
        };
    }, [tag]), panelStyle = _b.panelStyle, headerStyle = _b.headerStyle, tagBadgeStyle = _b.tagBadgeStyle, labelStyle = _b.labelStyle;
    // `data-marc-tag` is what "Přejít k poli" looks for (CZNA-1451): the panel is the
    // one element every rendering of a field shares, repeatable or not.
    return (React.createElement("div", { style: panelStyle, "data-marc-tag": tag },
        React.createElement("div", { style: headerStyle },
            React.createElement("span", { style: tagBadgeStyle }, tag),
            React.createElement("span", { style: labelStyle }, label),
            headerRight && React.createElement("div", { style: headerRightStyle }, headerRight)),
        React.createElement("div", { style: bodyStyle }, children)));
};
export default MarcFieldPanel;
